import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/index';
import { SummaryComponent } from './summary/index';
import { PackageComponent } from './package/index';
import { CheckoutComponent } from './checkout/index';
import { MyorderComponent } from './myorder/index';
import { MycartComponent } from './mycart/index';
import { OrdersummaryComponent } from './ordersummary/index';
import { OnholdComponent } from './onhold/index';
import { OnholdComponentp } from './onholdp/onholdp.component';
import { BatchuploadComponent } from './batchupload/batchupload.component';

const appRoutes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'home/:token/:a/:t/:p/:c/:qid/:bucket/:pno', component: HomeComponent },
    { path: 'checkout', component: CheckoutComponent },
    { path: 'package', component: PackageComponent },
    { path: 'summary', component: SummaryComponent },
    { path: 'myorder', component: MyorderComponent },
    { path: 'mycart', component: MycartComponent },
    { path: 'ordersummary', component: OrdersummaryComponent },
    { path: 'onhold', component: OnholdComponent },
    { path: 'onholdp', component: OnholdComponentp },
    { path: 'batchupload', component: BatchuploadComponent },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    // otherwise redirect to login
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
